import moment from 'moment/src/moment';
import attach from 'moment-timezone/src/moment/attach';

/*
 * This file is a custom wrapper for moment-timezone using our custom tzdata that only has
 * data for Europe/Helsinki and a couple of chosen timezones. This allows us to minimize
 * its size to a couple of kb.
 *
 * To use:
 *
 *   import [moment from] '/path/to/common/moment-timezone/moment-timezone';
 */

attach(moment).load(require('./tzdata.json')); // eslint-disable-line no-undef

export default moment;



// WEBPACK FOOTER //
// ./src/common/moment-timezone/moment-timezone.js